// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from "../../generated-types";

import gql from "graphql-tag";
import { DisplaySceneFragmentDoc } from "../Tour/tour.generated";
import * as Urql from "urql";
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type GetSceneByUuidQueryVariables = Types.Exact<{
  UUID: Types.Scalars["ID"];
}>;

export type GetSceneByUuidQuery = {
  __typename?: "Query";
  getSceneByUUID: {
    __typename?: "Scene";
    ID: number;
    UUID: string;
    name: string;
    narrative?: string | null;
    description?: string | null;
    updatedAt: any;
    muxPlaybackID?: string | null;
    status: Types.SceneStatus;
    reelID: string;
    estDuration?: number | null;
    actualDuration?: number | null;
    tourScene?: {
      __typename?: "TourScene";
      ID: number;
      displayOrder: number;
    } | null;
    tour?: {
      __typename?: "Tour";
      name: string;
      contract: { __typename?: "Contract"; name: string };
    } | null;
    model?: {
      __typename?: "MatterportModel";
      ID: number;
      photoURL?: string | null;
      matterportID: string;
      name: string;
      reels: Array<{
        __typename?: "MatterportReel";
        ID?: string | null;
        photoURL?: string | null;
        label?: string | null;
      }>;
    } | null;
  };
};

export const GetSceneByUuidDocument = gql`
  query GetSceneByUUID($UUID: ID!) {
    getSceneByUUID(UUID: $UUID) {
      ...DisplayScene
    }
  }
  ${DisplaySceneFragmentDoc}
`;

export function useGetSceneByUuidQuery(
  options: Omit<Urql.UseQueryArgs<GetSceneByUuidQueryVariables>, "query">
) {
  return Urql.useQuery<GetSceneByUuidQuery>({
    query: GetSceneByUuidDocument,
    ...options,
  });
}
